import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

import forprosjektsrapport from "../../assets/Forprosjektrapport.pdf";
import prosjektskisse from "../../assets/Prosjektskisse.pdf";
import statusrapport from "../../assets/Statusrapport.pdf";
import bacheloroppgaven from "../../assets/Bacheloroppgave.pdf";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  button: {
    width: "200px",
  },
}));

const ColorButton = withStyles({
  root: {
    boxShadow: "none",
    textTransform: "uppercase",
    fontSize: 14,
    padding: "6px 12px",
    border: "1px solid",
    lineHeight: 1.5,
    backgroundColor: "#877040",
    borderColor: "#877040",
    fontStyle: "uppercase",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#806939",
      borderColor: "#735e32",
      color: "#fff",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: "#735e32",
      borderColor: "#69562e",
      color: "#fff",
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
    },
  },
})(Button);

export default function Buttonz(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ColorButton
        className={classes.button}
        variant="contained"
        color="primary"
        href={statusrapport}
        endIcon={<PictureAsPdfIcon />}
      >
        Statusrapport
      </ColorButton>
      <ColorButton
        className={classes.button}
        variant="contained"
        color="primary"
        href={forprosjektsrapport}
        endIcon={<PictureAsPdfIcon />}
      >
        Forprosjekt
      </ColorButton>
      <ColorButton
        className={classes.button}
        variant="contained"
        color="primary"
        href={prosjektskisse}
        endIcon={<PictureAsPdfIcon />}
      >
        Prosjektskisse
      </ColorButton>
      <ColorButton
        className={classes.button}
        variant="contained"
        color="primary"
        href={bacheloroppgaven}
        endIcon={<PictureAsPdfIcon />}
      >
        Sluttrapport
      </ColorButton>
    </div>
  );
}
